export const generarAnios = () => {
    let arrayAnios: any = [];
    let date = new Date();
    let year = date.getFullYear();

    for (let index = 2020; index <= year; index++) {
        arrayAnios.push(index);
    }

    return arrayAnios;
}